import Application from "../../Application";
import { IStore } from "../../model/runtime/state/Store";

export default class LoadApplicationInteractor {
  private application: Application;
  private store: IStore;

  constructor(application, store) {
    this.application = application;
    this.store = store;
  }

  execute() {
    this.store.update({
      application: this.application
    });
  }
}
